<template>
  <div id="index" style="width: 340px;position: fixed;top:10%;left: 50%;margin-left: -170px;background: #fff;box-shadow: 0 5px 5px #e6e6e6;">
    <div class="p_d10"><img src="../../../assets/img/logo.png" height="60"/></div>
    <div class="p_d10 m_l_10 m_r_10 font14 ">{{$t('common.LogoutMsg')}}</div>
    <div class="p_d10 t_c"><button class="redButton font16 m_t_10 m_b_20" style="display: inline-block;border-radius: 4px;" @click="toGileadSSO">Gilead SSO Login</button></div>
  </div>
</template>
<script>
export default {
  name: 'logout',
  data () {
    return {
    }
  },
  created () {
    if (localStorage.coeToken && localStorage.coeToken !== '') {
      this.$router.replace({
        name: 'index'
      })
    }
  },
  methods: {
    toGileadSSO () {
      window.location.href = this.$baseUrl + 'Home/login'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/logout.vue